import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDeepTechNews, PreferenceNews } from 'src/app/core/domain/webinar';
import { getFavIconUrl } from '../../utils/common-methods';

@Component({
  selector: 'app-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss']
})
export class NewsCardComponent implements OnInit {
  @Input() item: IDeepTechNews;
  @Input() preferenceItem: PreferenceNews;
  @Output() categoryClicked = new EventEmitter<string>();
  constructor() { }

  ngOnInit(): void {
    const urlObj = new URL(this.preferenceItem.url);

    this.preferenceItem.host = urlObj.host;
    this.preferenceItem.favicon = getFavIconUrl(urlObj.hostname);
  }
onImgError(event: any) {
  event.target.src = '../../../../../assets/images/no-image.svg';
}
 onCategoryClick() {
    this.categoryClicked.emit(this.preferenceItem?.category?.name);
  }
}
